const hebrewMessages = {
  valueMissing: 'אנא מלא שדה זה.',
  typeMismatch: {
    email: 'אנא הזן כתובת אימייל תקינה.',
    tel: 'אנא הזן מספר טלפון תקין.',
    url: 'אנא הזן כתובת URL תקינה.'
  },
  patternMismatch: 'אנא התאם לפורמט הנדרש.',
  tooLong: 'הטקסט ארוך מדי.',
  tooShort: 'הטקסט קצר מדי.',
  rangeOverflow: 'הערך גדול מדי.',
  rangeUnderflow: 'הערך קטן מדי.',
  stepMismatch: 'הערך אינו תקין.'
};

// Function to get validation message
function getValidationMessage(input) {
  const validity = input.validity;

  if (validity.valueMissing) {
    return hebrewMessages.valueMissing;
  } else if (validity.typeMismatch) {
    const inputType = input.type;
    return hebrewMessages.typeMismatch[inputType] || hebrewMessages.typeMismatch.email;
  } else if (validity.patternMismatch) {
    return hebrewMessages.patternMismatch;
  } else if (validity.tooLong) {
    return hebrewMessages.tooLong;
  } else if (validity.tooShort) {
    return hebrewMessages.tooShort;
  } else if (validity.rangeOverflow) {
    return hebrewMessages.rangeOverflow;
  } else if (validity.rangeUnderflow) {
    return hebrewMessages.rangeUnderflow;
  } else if (validity.stepMismatch) {
    return hebrewMessages.stepMismatch;
  }
  return '';
}
// Function to create custom tooltip
function createCustomTooltip(input, message) {
  // Remove existing tooltip
  const existingTooltip = input.parentElement.querySelector('.custom-validation-message');
  if (existingTooltip) {
    existingTooltip.remove();
  }

  // Create new tooltip
  const tooltip = document.createElement('div');
  tooltip.className = 'custom-validation-message';
  tooltip.textContent = message;
  tooltip.style.display = 'block';

  // Insert tooltip after the input
  input.parentElement.appendChild(tooltip);

  // Auto hide after 5 seconds
  setTimeout(() => {
    if (tooltip.parentElement) {
      tooltip.remove();
    }
  }, 5000);

  return tooltip;
}
// Function to set custom validation message
function setCustomMessage(input) {
  const message = getValidationMessage(input);
  input.setCustomValidity(message);

  // Create custom tooltip for better appearance
  if (message && input.closest('.site-page')) {
    createCustomTooltip(input, message);
  }
}
// Function to remove custom tooltip
function removeCustomTooltip(input) {
  const tooltip = input.parentElement.querySelector('.custom-validation-message');
  if (tooltip) {
    tooltip.remove();
  }
}
function hebrewErrorText(inputs) {
  inputs.forEach(function (input) {
    // Set custom message on invalid event
    input.addEventListener('invalid', function (e) {
      setCustomMessage(this);

      if (this.closest('.site-page')) {
        e.preventDefault();
      }
    });

    // Clear custom message when input becomes valid
    input.addEventListener('input', function () {
      if (input.type === 'checkbox' && !input.checked) {
        const message = getValidationMessage(this);
        this.setCustomValidity(message);
      }
      else {
        this.setCustomValidity('');
        removeCustomTooltip(this)
      }
      if (this.validity.valid) {
        this.setCustomValidity('');
        removeCustomTooltip(this);
      } else {
        const message = getValidationMessage(this);
        this.setCustomValidity(message);
      }
    });

    // Handle focus events
    input.addEventListener('focus', function () {
      removeCustomTooltip(this);
    });

    // Also handle blur event
    input.addEventListener('blur', function () {
      if (!this.validity.valid) {
        setCustomMessage(this);
      }
    });
  });
}
document.addEventListener('submit', function (e) {
  const form = e.target;
  const invalidInputs = form.querySelectorAll(':invalid');

  if (invalidInputs.length > 0 && form.closest('.site-page')) {
    e.preventDefault();

    // Show custom tooltips for all invalid inputs
    invalidInputs.forEach(function (input) {
      const message = getValidationMessage(input);
      if (message) {
        createCustomTooltip(input, message);
        input.setCustomValidity(message);
      }
    });

    // Focus first invalid input
    invalidInputs[0].focus();
  }
});

// Initialize for existing inputs on page load
const inputs = document.querySelectorAll('input[required], textarea[required], select[required]');
hebrewErrorText(inputs);

// Track inputs that have already been initialized to avoid duplicate listeners
const initializedInputs = new WeakSet();
inputs.forEach(input => initializedInputs.add(input));

// MutationObserver to handle dynamically added content (popups, modals, etc.)
const observer = new MutationObserver(function(mutations) {
  mutations.forEach(function(mutation) {
    mutation.addedNodes.forEach(function(node) {
      // Check if the added node is an element
      if (node.nodeType === Node.ELEMENT_NODE) {
        // Find all required inputs in the added node
        const newInputs = node.querySelectorAll ? 
          node.querySelectorAll('input[required], textarea[required], select[required]') : 
          [];
        
        // Also check if the node itself is a required input
        const isRequiredInput = node.matches && 
          node.matches('input[required], textarea[required], select[required]');
        
        // Collect all new inputs that haven't been initialized yet
        const uninitializedInputs = [];
        
        if (isRequiredInput && !initializedInputs.has(node)) {
          uninitializedInputs.push(node);
          initializedInputs.add(node);
        }
        
        newInputs.forEach(function(input) {
          if (!initializedInputs.has(input)) {
            uninitializedInputs.push(input);
            initializedInputs.add(input);
          }
        });
        
        // Initialize Hebrew validation for new inputs
        if (uninitializedInputs.length > 0) {
          hebrewErrorText(uninitializedInputs);
        }
      }
    });
  });
});

// Start observing the document body for added nodes
observer.observe(document.body, {
  childList: true,
  subtree: true
});